const KEY = 'tamcare_shop_cart';
const listeners = new Set();

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(raw) ? raw : [];
  } catch (_) {
    return [];
  }
}

function write(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  listeners.forEach((fn) => fn(items));
}

export function getCart() {
  return read();
}

export function cartCount() {
  return read().reduce((sum, item) => sum + Number(item.quantity || 0), 0);
}

export function addToCart(product, quantity = 1) {
  const rawStock = product.stockQty ?? product.stock_qty;
  const hasStockCap = rawStock !== undefined && rawStock !== null && rawStock !== '';
  const stockCap = hasStockCap ? Math.max(0, Number(rawStock) || 0) : null;
  if (hasStockCap && stockCap <= 0) {
    return { ok: false, message: 'Sản phẩm đã hết hàng' };
  }
  const qty = Math.min(99, Math.max(1, Number(quantity) || 1));
  const items = read();
  const found = items.find((item) => Number(item.productId) === Number(product.id));
  const maxQty = hasStockCap ? Math.min(99, stockCap) : 99;
  if (found) {
    const nextQty = Number(found.quantity) + qty;
    if (hasStockCap && nextQty > maxQty) {
      return {
        ok: false,
        message: maxQty <= Number(found.quantity)
          ? 'Đã đạt số lượng tối đa trong kho'
          : `Chỉ còn ${maxQty} sản phẩm. Giỏ hiện có ${found.quantity}.`,
      };
    }
    found.quantity = Math.min(maxQty, nextQty);
    found.name = product.name;
    found.price = Number(product.price) || 0;
    found.imageUrl = product.imageUrl || found.imageUrl || '';
    found.stockQty = hasStockCap ? stockCap : found.stockQty;
  } else {
    if (hasStockCap && qty > maxQty) {
      return { ok: false, message: `Chỉ còn ${maxQty} sản phẩm trong kho` };
    }
    items.push({
      productId: Number(product.id),
      name: product.name,
      price: Number(product.price) || 0,
      imageUrl: product.imageUrl || '',
      stockQty: hasStockCap ? stockCap : undefined,
      quantity: Math.min(maxQty, qty),
    });
  }
  write(items);
  return { ok: true, items };
}

export function updateCartQty(productId, quantity) {
  const qty = Number(quantity);
  let items = read();
  if (!qty || qty < 1) {
    items = items.filter((item) => Number(item.productId) !== Number(productId));
  } else {
    items = items.map((item) => {
      if (Number(item.productId) !== Number(productId)) return item;
      const cap = Number(item.stockQty);
      const maxQty = Number.isFinite(cap) && cap > 0 ? Math.min(99, cap) : 99;
      return { ...item, quantity: Math.min(maxQty, qty) };
    });
  }
  write(items);
  return items;
}

export function clearCart() {
  write([]);
}

export function subscribeCart(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
